<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Προσωπικό</h4>
          <p class="card-title-desc">Διαχείριση και προσθήκη προσωπικού</p>
          <!-- <b-tabs pills justified content-class="p-3 text-muted"> -->
          <!-- <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
             -->
          <!-- <b-tab active class="border-0" ref="tab1"> -->
          <b-tabs content-class="p-3 text-muted">
            <b-tab active ref="tab1">
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-home"></i>
                </span>
                <span class="d-none d-sm-inline-block">ΧΡΗΣΤΕΣ</span>
              </template>

              <div class="row">
                <div class="col-xl-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <!-- <div class="col-sm-12 col-md-6"></div> -->

                        <div class="col-sm-12 col-md-12">
                          <div id="tickets-table_filter" class="dataTables_filter ">
                            <label class="d-inline-flex align-items-center">
                              Τμήματα:
                            </label>

                            <multiselect placeholder="Επιλογή τμημάτων" track-by="id" label="name"
                              :options="departmentNames" :multiple="true" v-model="departmentValue"
                              selectLabel="Eπιλογή Τμήματος" selectedLabel="Επιλέχθηκε" deselectLabel="Αποεπιλογή">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-4">
                        <div class="col-sm-12 col-md-4">
                          <div id="tickets-table_filter" class="dataTables_filter ">
                            <label class="d-inline-flex align-items-center">
                              Ρόλοι:

                              <multiselect placeholder="Επιλογή Ρόλων" :options="roleOptions" track-by="id" label="name"
                                :multiple="true" v-model="roleValue" selectLabel="Eπιλογή Ρόλου"
                                selectedLabel="Επιλέχθηκε" deselectLabel="Αποεπιλογή"></multiselect>
                            </label>
                          </div>

                        </div>

                        <div class="col-sm-7 col-md-4">
                          <div id="tickets-table_filter" class="dataTables_filter text-md">
                            <label class="d-inline-flex align-items-center">
                              Σχέση Εργασίας:

                              <multiselect placeholder="Επιλογή Σχέσης εργασίας" :options="employmentRelationShips"
                                track-by="id" label="title" :multiple="true" v-model="relationShipValue"
                                selectLabel="Eπιλογή Σχέσης εργασίας" selectedLabel="Επιλέχθηκε"
                                deselectLabel="Αποεπιλογή"></multiselect>
                            </label>
                          </div>

                        </div>

                        <!-- Search -->
                        <div class="col-sm-12 col-md-4">
                          <div id="tickets-table_filter" class="dataTables_filter text-md-center">
                            <label class="d-inline-flex align-items-center">
                              Αναζήτηση:
                              <b-input-group>
                                <b-form-input v-model="searchFilter" type="search"
                                  class="form-control form-control-sm ms-2"
                                  @keyup.enter="onSearchPerson"></b-form-input>
                                <b-input-group-append>
                                  <b-button v-if="searchFilter.length > 0" variant="danger"
                                    @click.prevent="onClearSearchPerson">
                                    <i class="bx bx-x"></i>
                                  </b-button>
                                  <b-button variant="primary" @click.prevent="onSearchPerson">
                                    <i class="bx bx-search-alt-2"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                              <div class="btn-group btn-group-sm" role="group">
                                <!-- <b-button
                                  variant="primary"
                                  @click.prevent="onSearchPerson"
                                >
                                  <i class="bx bx-search-alt-2"></i>
                                </b-button> -->
                              </div>
                            </label>
                          </div>
                        </div>

                        <!-- End search -->
                      </div>

                      <!-- Table -->

                      <div class="table-responsive">
                        <table class="table mb-0">
                          <thead class="table-light">
                            <tr>
                              <th>Α/Α</th>
                              <th>Επίθετο</th>
                              <th>Όνομα</th>
                              <th>Αριθμός Κάρτας</th>
                              <th>E-mail</th>
                              <th>Τμήμα</th>
                              <th>Ρόλος</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody v-if="
                            peopleData &&
                            peopleData.results &&
                            peopleData.results.length > 0
                          ">
                            <tr v-for="(person, index) in peopleData.results" :key="index">
                              <th scope="row">
                                <!-- {{ index + 1 }} -->
                                {{
                                  peopleData.current_page * perPage -
                                  perPage +
                                  index +
                                  1
                                }}
                              </th>

                              <!-- <td v-if="person.user && person.user[0]">
                                {{ person.user[0].last_name }}
                              </td> -->
                              <td>
                                {{ person.person_last_name }}
                              </td>

                              <td>
                                {{ person.person_first_name }}
                              </td>

                              <td v-if="person.person_card_number">
                                {{ person.person_card_number }}
                              </td>
                              <td v-else>
                                <i class="fas fa-exclamation" style="color:red"></i>
                              </td>
                              <td>
                                {{ person.person_email }}
                              </td>
                              <td v-if="person && person.department.length > 0">
                                {{ person.department.join(", ") }}
                              </td>
                              <td v-else>-</td>

                              <td>{{ translateRole(person.role) }}</td>
                              <td v-if="is_staff">
                                <router-link tag="a" :to="{
                                  name: 'staff-user',
                                  params: { id: person.id },
                                }">
                                  <i class="mdi mdi-pencil"></i>
                                  <i class="mdi mdi-trash-can" @click.prevent="confirm(person.id)"></i>
                                </router-link>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- End of table -->
                      <div class="row">
                        <div class="col">
                          <div class="dataTables_paginate paging_simple_numbers float-end">
                            <ul class="pagination pagination-rounded mb-0" v-if="peopleData.results">
                              {{
                                peopleData.results.count
                              }}
                              <!-- pagination -->
                              <b-pagination v-model="currentPage" :total-rows="peopleData.count"
                                :per-page="perPage"></b-pagination>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab @click.prevent="checkRequiredFieldsBeforeCreateUser" v-if="is_staff">
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-user-plus"></i>
                </span>
                <span class="d-none d-sm-inline-block">ΠΡΟΣΘΗΚΗ ΧΡΗΣΤΗ</span>
              </template>
              <FormStaff @completed="completedFormSubmit" />
            </b-tab>
          </b-tabs>
          <Drawer @close="upDrawer" :align="'up'" :closeable="true" :maskClosable="true" :zIndex="1002">
            <div v-if="isUpDrawer">
              <div class="offcanvas-header">
                <h5 id="offcanvasBottomLabel">Ενημέρωση</h5>
              </div>
              <div class="offcanvas-body">
                Θα πρέπει να γνωρίζετε ότι τα πεδία
                <strong>{{ drawerMsg }}</strong> είναι κενά και υποχρεωτικά.
                Παρακαλώ να τα συμπληρώσετε και ύστερα η προσθήκη χρήστη
              </div>
            </div>
          </Drawer>
          <Drawer @close="personEnrolledDrawer" :align="'up'" :closeable="true" :maskClosable="true" :zIndex="1002">
            <div v-if="isPersonEnrolledDrawer">
              <div class="offcanvas-header">
                <h5 id="offcanvasBottomLabel">Ενημέρωση</h5>
              </div>
              <div class="offcanvas-body">
                {{ drawerMsg }}
              </div>
            </div>
          </Drawer>
          <Drawer @close="personDeletedDrawer" :align="'up'" :closeable="true" :maskClosable="true" :zIndex="1002">
            <div v-if="isPersonDeletedDrawer">
              <div class="offcanvas-header">
                <h5 id="offcanvasBottomLabel">Ενημέρωση</h5>
              </div>
              <div class="offcanvas-body">
                {{ drawerMsg }}
              </div>
            </div>
          </Drawer>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
// import session from "../../../../api/session";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import { translateRole } from "../../../../translate_roles";

import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import { mapState, mapGetters } from "vuex";
import Drawer from "vue-simple-drawer";
import PageHeader from "@/components/page-header";
import { eventCreate } from "../../../../eventspy.js";
import FormStaff from "./CreatePersonForm.vue";
// import {
//   createUser,
//   createPersonDeviceIdentity,
//   createPersonWorkingSchedule,
//   createPersonContract,
// } from "../utils";
import session from "../../../../api/session";
// import CreatePerson from "./CreatePersonCards/index.vue";

export default {
  page: {
    title: "Προσωπικό",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect, Drawer, FormStaff },
  data() {
    return {
      title: "Προσωπικο",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "Προσωπικό",
          active: true,
        },
      ],
      isUpDrawer: false,
      isPersonEnrolledDrawer: false,
      isPersonDeletedDrawer: false,
      open: false,
      drawerMsg: "",
      currentPage: 1,
      perPage: 10,
      searchFilter: "",
      departmentValue: "",
      roleValue: "",
      relationShipValue: "",
      roleFilterValue: "",
      departmentFilterValues: "",
      peopleFilters: {
        page: 1,
        role: "",
        department: "",
        search_person: "",
        relationship_id: "",
      },
      peopleData: [],
      canCreatePerson: false,
    };
  },
  created() {
    this.$store.dispatch("utils/fetchRoleChoices");
    this.$store.dispatch("utils/fetchRolesCount");
    this.fetchAllPeople();
  },

  watch: {
    currentPage(value) {
      this.peopleFilters = {
        ...this.peopleFilters,
        page: value,
      };
      this.fetchAllPeople();
    },
    departmentValue(value) {
      // console.log(value);
      this.peopleFilters = {
        ...this.peopleFilters,
        department:
          value != undefined
            ? value.map((e) => (e.id != undefined ? e.id : ""))
            : "",
      };

      this.fetchAllPeople();
    },
    roleValue(value) {
      this.peopleFilters = {
        ...this.peopleFilters,
        role: value != undefined ? value.map((e) => e.id) : "",
      };
      this.fetchAllPeople();
    },
    relationShipValue(value) {
      this.peopleFilters = {
        ...this.peopleFilters,
        relationship_id: value != undefined ? value.map((e) => e.id) : "",
      };
      this.fetchAllPeople();
    },
  },

  computed: {
    ...mapGetters("auth", ["userLoggedIn", "is_staff", "is_superuser"]),
    ...mapState("utils", [
      "devices",
      "employmentRelationShips",
      "standarRoles",
      "roles",
      "departmentOptions",
      "roleChoices",
      "departments",
    ]),
    departmentNames() {
      // this.preFillDepartmentValue();
      return this.departmentOptions.map((e) => {
        return { id: e.id, name: e.department_parent_name };
      });
    },
    roleOptions() {
      return this.roleChoices
        .filter((e) => {
          return this.roles.map((r) => r.role).includes(e.role_id);
        })
        .map((role) => {
          return { id: role.role_id, name: role.role_name };
        });
    },
  },

  methods: {
    async fetchAllPeople() {
      const filterUrlParams = new URLSearchParams();

      Object.entries(this.peopleFilters).forEach(([key, values]) => {
        if (values) {
          if (Array.isArray(values)) {
            values.forEach((value) => {
              filterUrlParams.append(key, value);
            });
          } else {
            filterUrlParams.append(key, values);
          }
        }
      });
      await session
        .get(`api/employees/?${filterUrlParams.toString()}`)
        .then((resp) => {
          this.peopleData = resp.data;
          // console.log("People: ", resp.data);
        })
        .catch((e) => {
          console.log(e.response.data);
        });
    },
    preFillDepartmentValue() {
      if (!(this.is_staff || this.is_superuser)) {
        this.departmentValue = [
          this.departmentOptions.map((e) => {
            return { id: e.id, name: `${e.parent_name}/${e.name}` };
          })[0],
        ];
      }
    },
    deletePerson(personID) {
      setTimeout(() => {
        session.delete(`api/person/${personID}/delete/`).then(() => {
          this.fetchAllPeople();
        });
        this.drawerMsg =
          "Ολοκληρώθηκε η διαδικασία διαγραφής του χρήστη από τα ρολόγια!";
        this.personDeletedDrawer();
      }, 1000);
    },
    confirm(personID) {
      Swal.fire({
        title: "Είστε σίγουρος;",
        text: "Δεν θα μπορείτε να το επαναφέρετε!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι, διαγράψτε το!",
      }).then((result) => {
        if (result.value) {
          // console.log(personID);
          eventCreate(`Διέγραψε τον χρήστη ${personID}`, 3);
          this.deletePerson(personID);

          Swal.fire({
            title: "Διαγράφηκε!",
            text: "Ο χρήστης έχει διαγραφεί.Ο χρήστης θα διαγραφεί από όλα τα ρολόγια και θα ειδοποιηθείτε μόλις ολοκληρωθεί η διαδικασία.",
            icon: "success",
            timer: 3000,
          });
        }
      });
    },
    translateRole,
    // ...mapActions("people", ["fetchAllPeople", "fetchPeopleByFilters"]),
    onClearSearchPerson() {
      this.peopleFilters.person = "";
      this.searchFilter = "";
      this.peopleFilters = {
        ...this.peopleFilters,
        search_person: "",
      };
      this.fetchAllPeople();
    },
    onSearchPerson() {
      this.peopleFilters.person = this.searchFilter;
      this.peopleFilters.page = 1;

      this.peopleFilters = {
        ...this.peopleFilters,
        search_person: this.searchFilter,
      };
      this.fetchAllPeople();
    },
    checkRequiredFieldsBeforeCreateUser() {
      const requiredFields = {
        Συσκευές: this.devices.length,
        "Σχέση Εργασίας": this.employmentRelationShips.length,
      };
      const emptyKeys = [];
      Object.entries(requiredFields).forEach(([key, value]) => {
        if (value == 0) {
          emptyKeys.push(key);
        }
      });
      if (emptyKeys.length > 0) {
        this.drawerMsg = emptyKeys.join(", ");
        this.upDrawer();
      }
    },
    successmsg() {
      Swal.fire(
        "Ολοκλήρωθηκε!",
        "Η εγγραφή χρήστη ολοκληρώθκε με επιτυχία!  Ο χρήστης θα προστεθεί σε όλα τα ρολόγια και θα ειδοποιηθείτε μόλις ολοκληρωθεί η διαδικασία.",
        "success"
      );
    },
    toggle() {
      this.open = !this.open;
    },
    upDrawer() {
      this.isUpDrawer = !this.isUpDrawer;
    },
    personEnrolledDrawer() {
      this.isPersonEnrolledDrawer = !this.isPersonEnrolledDrawer;
    },
    personDeletedDrawer() {
      this.isPersonDeletedDrawer = !this.isPersonDeletedDrawer;
    },
    completedFormSubmit() {
      this.successmsg();
      this.$refs.tab1.activate();
      this.fetchAllPeople();
    },
  },
};
</script>

<style scoped>
.mdi-pencil {
  padding: 10px;
  color: rgb(224, 151, 15);
  transition: all 0.4s;
  margin-right: 5px;
  cursor: pointer;
  font-size: 20px;
}

.mdi-trash-can {
  color: red;
  padding: 10px;
  transition: all 0.6s;
  cursor: pointer;
  font-size: 20px;
}
</style>
